import {Component, forwardRef} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NumberInputComponent} from '../number-input.component';

@Component({
    selector: 'kiwi-currency-input',
    templateUrl: './input-with-unit.component.html',
    styleUrls: ['./input-with-unit.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CurrencyInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CurrencyInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CurrencyInputComponent extends NumberInputComponent {
    constructor() {
        super();
        this.unit = 'common.change.euros';
        this.step = 0.01;
    }
}
